/* Engineezy Jobs board — renders the public jobs.json feed into #ezj-board. No dependencies. */
(function () {
  var root = document.getElementById('ezj-board');
  if (!root) return;

  var DATA_URL = root.getAttribute('data-src');
  var PAGE = 40;
  var LEVELS = ['Internship', 'Entry level', 'Mid level', 'Senior'];
  var FILTER_KEYS = ['q', 'hobby', 'level', 'discipline', 'sector', 'company', 'country', 'city', 'remote'];
  // Interests shown as chips; companies are tagged with these in companies.json ("hobbies").
  var HOBBIES = [
    ['Cycling', '🚵'], ['Snow sports', '🏂'], ['Climbing & mountaineering', '🧗'], ['Camping & outdoors', '🏕️'],
    ['Water sports & boating', '🏄'], ['Motorsports & powersports', '🏁'], ['Cars & tuning', '🏎️'], ['Aviation & drones', '✈️'],
    ['Space & rocketry', '🚀'], ['RC & models', '🛩️'], ['Music & audio', '🎸'], ['Gaming & VR', '🎮'],
    ['Toys & games', '🧸'], ['3D printing & making', '🛠️'], ['Photography & video', '📷'], ['Theme parks & rides', '🎢'],
    ['Film & special effects', '🎬'], ['Running & fitness', '🏃'], ['Golf & racquet sports', '⛳'], ['Team sports', '🏒'],
    ['Skate & scooters', '🛹'], ['Hunting, fishing & archery', '🎣'], ['Coffee & cooking', '☕'], ['Watches & everyday carry', '⌚']
  ];
  var LAST = { 'Other': 1, 'Other engineering': 1 };

  var state = {};
  FILTER_KEYS.forEach(function (k) { state[k] = ''; });
  var params = new URLSearchParams(location.search);
  FILTER_KEYS.forEach(function (k) { if (params.get(k)) state[k] = params.get(k); });
  if (!state.country) state.city = '';

  var data = null, jobs = [], filtered = [], shown = PAGE;
  var ui = {}, combos = {};

  // ---------- helpers
  function el(tag, attrs, children) {
    var n = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      var v = attrs[k];
      if (v == null || v === false) return;
      if (k === 'text') n.textContent = v;
      else if (k === 'class') n.className = v;
      else if (k.slice(0, 2) === 'on') n.addEventListener(k.slice(2), v);
      else n.setAttribute(k, v === true ? '' : v);
    });
    (children || []).forEach(function (c) { if (c) n.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return n;
  }
  function debounce(fn, ms) { var t; return function (e) { clearTimeout(t); t = setTimeout(function () { fn(e); }, ms); }; }
  function track(name, detail) {
    try { window.Shopify && Shopify.analytics && Shopify.analytics.publish && Shopify.analytics.publish(name, detail); } catch (e) {}
    try { window.gtag && gtag('event', name, detail); } catch (e) {}
  }
  function ago(d) {
    if (!d) return '';
    var days = Math.floor((Date.now() - new Date(d + 'T00:00:00Z')) / 864e5);
    if (days <= 0) return 'Today';
    if (days === 1) return '1 day ago';
    if (days < 30) return days + ' days ago';
    var m = Math.floor(days / 30);
    return m === 1 ? '1 month ago' : m + ' months ago';
  }
  function syncUrl() {
    var p = new URLSearchParams(location.search);
    FILTER_KEYS.forEach(function (k) { state[k] ? p.set(k, state[k]) : p.delete(k); });
    p.delete('customer_posted');
    var qs = p.toString();
    history.replaceState(null, '', location.pathname + (qs ? '?' + qs : '') + location.hash);
  }

  // ---------- filtering
  function matches(j, skip) {
    if (skip !== 'hobby' && state.hobby && j.h.indexOf(state.hobby) < 0) return false;
    if (skip !== 'level' && state.level && j.l !== state.level) return false;
    if (skip !== 'discipline' && state.discipline && j.d !== state.discipline) return false;
    if (skip !== 'sector' && state.sector && j.sector !== state.sector) return false;
    if (skip !== 'company' && state.company && j.company !== state.company) return false;
    if (skip !== 'country' && skip !== 'city' && state.country) {
      if (state.city) {
        var hit = false;
        for (var i = 0; i < j.p.length; i++) if (j.p[i][1] === state.country && j.p[i][0] === state.city) { hit = true; break; }
        if (!hit) return false;
      } else if (j.countries.indexOf(state.country) < 0) return false;
    }
    if (skip === 'city' && state.country && j.countries.indexOf(state.country) < 0) return false;
    if (state.remote && !j.r) return false;
    if (state.q) {
      var words = state.q.toLowerCase().split(/\s+/);
      for (var w = 0; w < words.length; w++) if (words[w] && j.hay.indexOf(words[w]) < 0) return false;
    }
    return true;
  }

  function counts(key) {
    var m = {};
    for (var i = 0; i < jobs.length; i++) {
      var j = jobs[i];
      if (!matches(j, key)) continue;
      var vals;
      if (key === 'country') vals = j.countries;
      else if (key === 'hobby') vals = j.h;
      else if (key === 'city') {
        vals = [];
        for (var k = 0; k < j.p.length; k++) if (j.p[k][0] && j.p[k][1] === state.country && vals.indexOf(j.p[k][0]) < 0) vals.push(j.p[k][0]);
      } else vals = [key === 'discipline' ? j.d : key === 'level' ? j.l : j[key]];
      for (var v = 0; v < vals.length; v++) if (vals[v]) m[vals[v]] = (m[vals[v]] || 0) + 1;
    }
    return m;
  }

  // ---------- autocomplete combobox
  // Browsers read "Company", "Country" and "City" as an address form and offer the user's address.
  // Chrome ignores autocomplete="off" there but skips fields with a value it doesn't recognize;
  // Safari skips fields whose name or id contains "search".
  var NO_AUTOFILL = 'ezj-filter';
  var comboId = 0;
  function Combo(key, label, placeholder) {
    var id = 'ezj-search-cb-' + (++comboId);
    var self = this;
    this.key = key; this.options = []; this.active = -1; this.open = false;
    this.input = el('input', {
      class: 'ezj-cb-input', id: id, name: 'ezj-search-' + key, type: 'text', role: 'combobox', autocomplete: NO_AUTOFILL, spellcheck: 'false',
      'aria-autocomplete': 'list', 'aria-expanded': 'false', 'aria-controls': id + '-list', placeholder: placeholder,
      oninput: function () { self.active = 0; self.show(); },
      onfocus: function () { self.input.select(); self.show(); },
      onkeydown: function (e) { self.key_(e); },
      onblur: function () { setTimeout(function () { self.hide(); self.restore(); }, 120); }
    });
    this.list = el('ul', { class: 'ezj-cb-list', id: id + '-list', role: 'listbox', 'aria-label': label });
    this.clear = el('button', {
      type: 'button', class: 'ezj-cb-clear', 'aria-label': 'Clear ' + label, text: '×',
      onclick: function () { self.choose(''); self.input.focus(); }
    });
    this.node = el('div', { class: 'ezj-cb' }, [
      el('label', { class: 'ezj-cb-label', for: id, text: label }),
      el('div', { class: 'ezj-cb-field' }, [this.input, this.clear]),
      this.list
    ]);
  }
  Combo.prototype.setOptions = function (m) {
    this.counts = m;
    this.options = Object.keys(m).sort(function (a, b) {
      if (LAST[a] !== LAST[b]) return LAST[a] ? 1 : -1;
      return m[b] - m[a] || a.localeCompare(b);
    });
    this.restore();
    if (this.open) this.show();
  };
  Combo.prototype.restore = function () {
    if (document.activeElement !== this.input) this.input.value = state[this.key];
    this.node.classList.toggle('is-set', !!state[this.key]);
  };
  Combo.prototype.visible = function () {
    var q = this.input.value.trim().toLowerCase();
    if (!q || q === (state[this.key] || '').toLowerCase()) return this.options;
    var starts = [], has = [];
    this.options.forEach(function (o) {
      var lo = o.toLowerCase();
      if (lo.indexOf(q) === 0 || lo.indexOf(' ' + q) > 0) starts.push(o);
      else if (lo.indexOf(q) > 0) has.push(o);
    });
    return starts.concat(has);
  };
  Combo.prototype.show = function () {
    var self = this, items = this.visible().slice(0, 60);
    this.shownItems = items;
    if (this.active >= items.length) this.active = items.length - 1;
    this.list.innerHTML = '';
    if (!items.length) this.list.appendChild(el('li', { class: 'ezj-cb-empty', text: 'No matches' }));
    items.forEach(function (o, i) {
      var li = el('li', {
        role: 'option', id: self.list.id + '-' + i, class: 'ezj-cb-opt' + (i === self.active ? ' is-active' : ''),
        'aria-selected': String(o === state[self.key]),
        onmousedown: function (e) { e.preventDefault(); self.choose(o); }
      }, [el('span', { text: o }), el('span', { class: 'ezj-cb-n', text: (self.counts[o] || 0).toLocaleString() })]);
      self.list.appendChild(li);
    });
    this.open = true;
    this.node.classList.add('is-open');
    this.input.setAttribute('aria-expanded', 'true');
    this.input.setAttribute('aria-activedescendant', this.active >= 0 && items.length ? this.list.id + '-' + this.active : '');
    var act = this.list.children[this.active];
    if (act && act.scrollIntoView) act.scrollIntoView({ block: 'nearest' });
  };
  Combo.prototype.hide = function () {
    this.open = false; this.active = -1;
    this.node.classList.remove('is-open');
    this.input.setAttribute('aria-expanded', 'false');
  };
  Combo.prototype.choose = function (v) {
    state[this.key] = v;
    if (this.key === 'country') state.city = '';
    this.input.value = v;
    this.hide();
    update();
  };
  Combo.prototype.key_ = function (e) {
    var n = (this.shownItems || []).length;
    if (e.key === 'ArrowDown') { e.preventDefault(); if (!this.open) this.show(); this.active = Math.min(n - 1, this.active + 1); this.show(); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); this.active = Math.max(0, this.active - 1); this.show(); }
    else if (e.key === 'Enter') {
      e.preventDefault();
      var pick = this.shownItems && this.shownItems[this.active >= 0 ? this.active : 0];
      if (!this.input.value.trim()) this.choose('');
      else if (pick) this.choose(pick);
    }
    else if (e.key === 'Escape') { this.hide(); this.input.value = state[this.key]; }
  };
  Combo.prototype.disable = function (on, placeholder) {
    this.input.disabled = on;
    this.node.classList.toggle('is-disabled', on);
    this.input.placeholder = placeholder;
  };

  // ---------- render
  function buildShell() {
    root.innerHTML = '';
    ui.search = el('input', {
      class: 'ezj-search', type: 'search', name: 'ezj-search', autocomplete: NO_AUTOFILL, placeholder: 'Search job titles, companies, cities…', 'aria-label': 'Search jobs',
      oninput: debounce(function (e) { state.q = e.target.value.trim(); update(); }, 150)
    });
    ui.search.value = state.q;
    ui.levels = el('div', { class: 'ezj-chips', role: 'group', 'aria-label': 'Experience level' });
    ui.hobbies = el('div', { class: 'ezj-hobbies', role: 'group', 'aria-label': 'Interests' });

    combos.discipline = new Combo('discipline', 'Discipline', 'Any discipline');
    combos.sector = new Combo('sector', 'Industry', 'Any industry');
    combos.company = new Combo('company', 'Company', 'Any company');
    combos.country = new Combo('country', 'Country', 'Any country');
    combos.city = new Combo('city', 'City', 'Pick a country first');

    ui.remote = el('label', { class: 'ezj-toggle' }, [
      el('input', { type: 'checkbox', checked: !!state.remote, onchange: function (e) { state.remote = e.target.checked ? '1' : ''; update(); } }),
      ' Remote only'
    ]);
    ui.reset = el('button', { type: 'button', class: 'ezj-reset', text: 'Clear all filters', onclick: function () {
      FILTER_KEYS.forEach(function (k) { state[k] = ''; });
      ui.search.value = ''; ui.remote.querySelector('input').checked = false;
      update();
    } });
    ui.count = el('p', { class: 'ezj-count', 'aria-live': 'polite' });
    ui.list = el('ul', { class: 'ezj-list' });
    ui.more = el('button', { type: 'button', class: 'ezj-more', onclick: function () { shown += PAGE; renderList(); } });

    root.appendChild(el('section', { class: 'ezj-interests', 'aria-labelledby': 'ezj-interests-title' }, [
      el('h2', { class: 'ezj-interests-title', id: 'ezj-interests-title', text: 'Engineer the stuff you love' }),
      el('p', { class: 'ezj-interests-sub', text: 'Pick a hobby to see engineering jobs at the companies behind it.' }),
      ui.hobbies
    ]));
    root.appendChild(el('div', { class: 'ezj-filters' }, [
      ui.search,
      ui.levels,
      el('div', { class: 'ezj-combos' }, ['discipline', 'sector', 'company', 'country', 'city'].map(function (k) { return combos[k].node; })),
      el('div', { class: 'ezj-filter-foot' }, [ui.remote, ui.reset])
    ]));
    root.appendChild(el('div', { class: 'ezj-results-head' }, [
      ui.count,
      el('p', { class: 'ezj-source-note', text: 'Every listing links to the company’s own careers site. Engineezy doesn’t post these jobs or see applications.' })
    ]));
    root.appendChild(ui.list);
    root.appendChild(ui.more);
  }

  function renderFacets() {
    var hb = counts('hobby');
    ui.hobbies.innerHTML = '';
    HOBBIES.forEach(function (h) {
      var name = h[0], on = state.hobby === name, n = hb[name] || 0;
      if (!n && !on) return;
      ui.hobbies.appendChild(el('button', {
        type: 'button', class: 'ezj-hobby' + (on ? ' is-on' : ''), 'aria-pressed': String(on),
        onclick: function () { state.hobby = on ? '' : name; update(); }
      }, [el('span', { class: 'ezj-hobby-icon', 'aria-hidden': 'true', text: h[1] }), el('span', { class: 'ezj-hobby-name', text: name }), el('span', { class: 'ezj-hobby-n', text: n.toLocaleString() + ' jobs' })]));
    });
    var lv = counts('level');
    ui.levels.innerHTML = '';
    [''].concat(LEVELS).forEach(function (l) {
      var on = state.level === l;
      ui.levels.appendChild(el('button', {
        type: 'button', class: 'ezj-chip' + (on ? ' is-on' : ''), 'aria-pressed': String(on),
        onclick: function () { state.level = on && l ? '' : l; update(); }
      }, [l || 'All levels', l ? el('span', { class: 'ezj-chip-n', text: (lv[l] || 0).toLocaleString() }) : null]));
    });
    ['discipline', 'sector', 'company', 'country'].forEach(function (k) { combos[k].setOptions(counts(k)); });
    if (state.country) {
      combos.city.disable(false, 'Any city in ' + state.country);
      combos.city.setOptions(counts('city'));
    } else {
      combos.city.disable(true, 'Pick a country first');
      combos.city.setOptions({});
    }
    ui.reset.hidden = !FILTER_KEYS.some(function (k) { return state[k]; });
  }

  // The job's places that have a city, the filtered country's first.
  function namedPlaces(j) {
    var named = j.p.filter(function (p) { return p[0]; });
    if (state.country) named = named.filter(function (p) { return p[1] === state.country; }).concat(named.filter(function (p) { return p[1] !== state.country; }));
    return named;
  }

  function placeText(j) {
    var named = namedPlaces(j);
    if (!named.length) return j.countries.join(', ');
    var first = named[0][0] + ', ' + named[0][1];
    var more = j.p.length - 1;
    return more > 0 ? first + ' + ' + more + ' more' : first;
  }

  function jobItem(j) {
    var onApply = function () {
      var first = namedPlaces(j)[0], country = first ? first[1] : j.countries[0] || 'Unknown';
      track('eezy_job_apply', {
        company: j.company, title: j.t, level: j.l, discipline: j.d,
        location: first ? first[0] + ', ' + first[1] : country, country: country,
        interest: state.hobby || '(none)'
      });
    };
    var meta = [placeText(j), j.r ? 'Remote' : '', j.s || ''].filter(Boolean);
    return el('li', { class: 'ezj-job' }, [
      el('div', { class: 'ezj-job-main' }, [
        el('p', { class: 'ezj-job-co' }, [el('strong', { text: j.company }), el('span', { class: 'ezj-dot', 'aria-hidden': 'true', text: '·' }), j.sector]),
        el('h3', { class: 'ezj-job-title' }, [el('a', { href: j.u, target: '_blank', rel: 'noopener', text: j.t, onclick: onApply })]),
        el('p', { class: 'ezj-job-meta', title: j.p.map(function (x) { return [x[0], x[1]].filter(Boolean).join(', '); }).join(' / '), text: meta.join('  ·  ') }),
        el('div', { class: 'ezj-tags' }, [
          el('span', { class: 'ezj-tag ezj-tag--' + j.l.split(' ')[0].toLowerCase(), text: j.l }),
          el('span', { class: 'ezj-tag', text: j.d })
        ])
      ]),
      el('div', { class: 'ezj-job-side' }, [
        el('span', { class: 'ezj-ago', text: ago(j.at) }),
        el('a', {
          class: 'ezj-apply', href: j.u, target: '_blank', rel: 'noopener',
          'aria-label': 'Apply on ' + j.company + '’s careers site (opens in a new tab)', onclick: onApply
        }, ['Apply on company site ', el('span', { 'aria-hidden': 'true', text: '↗' })])
      ])
    ]);
  }

  function renderList() {
    ui.list.innerHTML = '';
    var frag = document.createDocumentFragment();
    filtered.slice(0, shown).forEach(function (j) { frag.appendChild(jobItem(j)); });
    ui.list.appendChild(frag);
    if (!filtered.length) {
      ui.list.appendChild(el('li', { class: 'ezj-empty' }, [
        el('strong', { text: 'No jobs match those filters.' }), el('br'),
        'Try clearing a filter, or join the job alerts above and we’ll send new ones as they open.'
      ]));
    }
    var left = filtered.length - shown;
    ui.more.hidden = left <= 0;
    ui.more.textContent = 'Show ' + Math.min(PAGE, left) + ' more of ' + left.toLocaleString();
  }

  function update() {
    shown = PAGE;
    filtered = jobs.filter(function (j) { return matches(j); });
    ui.count.textContent = filtered.length.toLocaleString() + (filtered.length === 1 ? ' job' : ' jobs');
    renderFacets();
    renderList();
    syncUrl();
  }

  function setStats() {
    var n = jobs.length;
    var companies = data.companies.filter(function (c) { return c.jobs; }).length;
    var updated = new Date(data.generatedAt);
    document.querySelectorAll('[data-ezj-stat]').forEach(function (s) {
      var k = s.getAttribute('data-ezj-stat');
      if (k === 'jobs') s.textContent = n.toLocaleString();
      if (k === 'companies') s.textContent = companies.toLocaleString();
      if (k === 'updated') s.textContent = updated.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
    });
  }

  // Feed v3 stores jobs as arrays: [title, company, level, discipline, places, urlSuffix, postedAt, remote, salary?]
  function prepare(d) {
    jobs = new Array(d.jobs.length);
    for (var i = 0; i < d.jobs.length; i++) {
      var r = d.jobs[i], co = d.companies[r[1]] || {}, p = [], countries = [];
      for (var k = 0; k < r[4].length; k += 2) {
        var country = d.countries[r[4][k + 1]];
        p.push([r[4][k] || null, country]);
        if (country && countries.indexOf(country) < 0) countries.push(country);
      }
      var j = {
        t: r[0], company: co.name || '', sector: co.sector || 'Other', h: co.h || [], l: d.levels[r[2]], d: d.disciplines[r[3]],
        p: p, countries: countries, u: withUtm((co.up || '') + r[5]), at: r[6] || null, r: r[7], s: r[8]
      };
      j.hay = (j.t + ' ' + j.company + ' ' + j.sector + ' ' + j.d + ' ' + p.map(function (x) { return (x[0] || '') + ' ' + x[1]; }).join(' ')).toLowerCase();
      jobs[i] = j;
    }
  }

  function withUtm(u) {
    try {
      var url = new URL(u);
      url.searchParams.set('utm_source', 'engineezy');
      url.searchParams.set('utm_medium', 'jobs_board');
      return url.toString();
    } catch (e) { return u; }
  }

  root.innerHTML = '<p class="ezj-loading">Loading jobs…</p>';
  fetch(DATA_URL, { cache: 'no-cache' })
    .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
    .then(function (d) {
      data = d;
      prepare(d);
      setStats();
      buildShell();
      update();
    })
    .catch(function () {
      root.innerHTML = '<p class="ezj-loading">Couldn’t load jobs right now. Refresh to try again.</p>';
    });

  // Optional interest picker for the job-alerts form. "No preference" is the default and is
  // re-selected whenever nothing else is ticked, so skipping it is always a valid answer.
  function hobbyTag(name) { return 'hobby-' + name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
  document.querySelectorAll('[data-ezj-interests]').forEach(function (slot, n) {
    var id = 'ezj-interests-' + n;
    var any = el('input', { type: 'checkbox', checked: true });
    var picks = HOBBIES.map(function (h) { return el('input', { type: 'checkbox', name: 'ezj-hobby', value: hobbyTag(h[0]), 'data-name': h[0] }); });
    var summaryText = el('span', { text: '' });
    var summary = el('summary', { class: 'ezj-input ezj-pick-summary', 'aria-describedby': id + '-hint' }, [el('span', { class: 'ezj-visually-hidden', text: 'Interests: ' }), summaryText]);
    var box = el('details', { class: 'ezj-pick' }, [summary, el('fieldset', { class: 'ezj-pick-list' }, [
      el('legend', { class: 'ezj-visually-hidden', text: 'Interests' }),
      el('label', { class: 'ezj-pick-opt ezj-pick-opt--any' }, [any, el('span', { text: 'No preference, send me everything' })])
    ].concat(picks.map(function (cb, i) {
      return el('label', { class: 'ezj-pick-opt' }, [cb, el('span', { class: 'ezj-pick-icon', 'aria-hidden': 'true', text: HOBBIES[i][1] }), el('span', { text: HOBBIES[i][0] })]);
    })))]);
    function refresh() {
      var on = picks.filter(function (cb) { return cb.checked; }).map(function (cb) { return cb.getAttribute('data-name'); });
      any.checked = !on.length;
      summaryText.textContent = !on.length ? 'All interests (no preference)'
        : on.slice(0, 2).join(', ') + (on.length > 2 ? ' +' + (on.length - 2) + ' more' : '');
    }
    any.addEventListener('change', function () { picks.forEach(function (cb) { cb.checked = false; }); refresh(); });
    picks.forEach(function (cb) { cb.addEventListener('change', refresh); });
    document.addEventListener('click', function (e) { if (box.open && !box.contains(e.target)) box.open = false; });
    box.addEventListener('keydown', function (e) { if (e.key === 'Escape' && box.open) { box.open = false; summary.focus(); } });
    refresh();
    slot.appendChild(el('p', { class: 'ezj-label', text: 'Interests ' }, [el('span', { class: 'ezj-optional', text: '(optional)' })]));
    slot.appendChild(el('p', { class: 'ezj-pick-hint', id: id + '-hint', text: 'Pick the hobbies you’d love to work in, or skip it for a mix of everything.' }));
    slot.appendChild(box);
  });

  // Sign-up forms: turn the "I am a…" choice and any interests into Shopify customer tags,
  // and show a thank-you after Shopify redirects back with ?customer_posted=true#<form id>.
  document.querySelectorAll('[data-ezj-form]').forEach(function (wrap) {
    var f = wrap.querySelector('form');
    if (!f) return;
    var base = wrap.getAttribute('data-ezj-form');
    f.addEventListener('submit', function () {
      var role = f.querySelector('[name="ezj-role"]');
      var tags = f.querySelector('[name="contact[tags]"]');
      var hobbies = [].map.call(f.querySelectorAll('[name="ezj-hobby"]:checked'), function (cb) { return cb.value; });
      if (f.querySelector('[data-ezj-interests]') && !hobbies.length) hobbies = ['hobby-any'];
      if (tags) tags.value = [base].concat(role && role.value ? [role.value] : [], hobbies).join(', ');
      track('eezy_jobs_signup', { list: base, role: role ? role.value : '', hobbies: hobbies.join(',') });
    });
    if (params.get('customer_posted') === 'true' && location.hash === '#' + f.id) wrap.classList.add('is-done');
  });
})();
